import EventEmitter from 'events'

export const emitter = new EventEmitter()

export const EVENT_SHOW_SIGN_IN_MODAL = 'EVENT_SHOW_SIGN_IN_MODAL'
